import React from 'react';
import { BsBoundingBoxCircles } from '@react-icons/all-files/bs/BsBoundingBoxCircles';

import { decorateComponent } from '../../../documentComponents';
import { ImageMapLink } from './ImageMapLink';
import { ImageMapLinkInspector } from './ImageMapLink.Inspector';

export default decorateComponent(ImageMapLink, 'block', {
  id: 'imageMapLink',
  label: '이미지 영역 링크',
  disabledMove: true,
  allowedParent: ['image'],
  allowedChildren: [],
  disallowedAncestors: [
    'a',
    'coupon',
    'tabButton',
  ],
  defaultProps: {
    to: 'https://ohou.se',
    openOption: 'sameTab',
    style: {
      top: '25%',
      left: '25%',
      width: '50%',
      height: '50%',
    },
  },
  renderIcon: () => <BsBoundingBoxCircles />,
  renderInspector: ImageMapLinkInspector,
});
